import ZuiContainer from '@zenbusiness/zui/Container';
import ZuiDialog from '@zenbusiness/zui/Dialog';
import ZuiHeading from '@zenbusiness/zui/Heading';
import { superstyled } from '@zenbusiness/zui/styles';

export const Root = superstyled({
  name: 'WebinarDialog',
  slot: 'Root',
  tag: ZuiDialog,
  styles: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
});

export const Content = superstyled({
  name: 'WebinarDialog',
  slot: 'Content',
  styles: ({ theme }) => ({
    backgroundColor: theme.palette.fixed.black,
    color: theme.palette.fixed.white,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    height: '100%',
  }),
});

export const Header = superstyled({
  name: 'WebinarDialog',
  slot: 'Header',
  styles: ({ theme }) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    paddingLeft: '0.5rem',
    minHeight: '3rem',

    [theme.breakpoints.up('md')]: {
      minHeight: '3.5rem',
    },
  }),
});

export const Title = superstyled({
  name: 'WebinarDialog',
  slot: 'Title',
  tag: ZuiHeading,
  propsAdded: {
    align: 'center',
    size: 'xl',
  },
  styles: {
    color: 'inherit',
  },
});

export const Body = superstyled({
  name: 'WebinarDialog',
  slot: 'Body',
  tag: ZuiContainer,
  styles: ({ theme }) => ({
    [theme.breakpoints.up('md')]: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100%',
    },
  }),
});
